import { z } from 'zod';
import { CONTACT_CATEGORIES } from './contacts.js';
/**
 * Touch Rules / cadences (v2.0, Phase 14c). A rule is a named, ordered cadence
 * template for a contact category; a contact is enrolled in ≤1 rule from an
 * anchor date; each cadence step is logged once (the "done" marker). The due
 * queue is `anchor + offsetDays ≤ now` and not-yet-logged. Shared client↔server.
 */
const uuid = z.string().uuid();
export const TOUCH_CHANNELS = ['call', 'email', 'sms', 'mail', 'task'];
export const touchCadenceSchema = z.object({
    position: z.number().int().min(0).max(999).default(0),
    substatus: z.string().max(80).optional(),
    offsetDays: z.number().int().min(0).max(3650),
    channels: z.array(z.enum(TOUCH_CHANNELS)).min(1).max(TOUCH_CHANNELS.length),
});
export const touchRuleCreateSchema = z.object({
    name: z.string().min(1).max(120),
    category: z.enum(CONTACT_CATEGORIES).default('client'),
    cadences: z.array(touchCadenceSchema).max(50).default([]),
});
export const touchRuleUpdateSchema = z.object({
    name: z.string().min(1).max(120).optional(),
    category: z.enum(CONTACT_CATEGORIES).optional(),
    cadences: z.array(touchCadenceSchema).max(50).optional(), // full-replace when present
});
export const touchEnrollSchema = z.object({
    ruleId: uuid,
    anchorAt: z.coerce.date().optional(), // defaults to now server-side
});
export const touchLogSchema = z.object({
    channel: z.enum(TOUCH_CHANNELS),
});
// ── Free-form contact touch log (V34 "Touches" popover) ──
// Distinct from the cadence channels above: this records any logged interaction
// with its outcome, powering the popover's ACTIONS counts + History.
export const CONTACT_TOUCH_CHANNELS = ['call', 'email', 'sms', 'meeting', 'note', 'other'];
export const CONTACT_TOUCH_OUTCOMES = [
    'connected',
    'no_answer',
    'left_message',
    'bounced',
    'replied',
    'other',
];
export const contactTouchCreateSchema = z.object({
    channel: z.enum(CONTACT_TOUCH_CHANNELS).default('other'),
    outcome: z.enum(CONTACT_TOUCH_OUTCOMES).default('other'),
    label: z.string().max(80).optional(),
    note: z.string().max(2000).optional(),
    // When set, the firing action also moves the contact to this status — the
    // resulting status change is recorded under the action's `label`.
    setStatusId: z.string().uuid().optional(),
});
//# sourceMappingURL=touch.js.map